module.exports = __webpack_public_path__ + "img/endPoint.e0a27d0d.png";